const buttonStyles = {
	position: 'fixed', 
	bottom: 25,
	left: 0
}

export default {buttonStyles}